<template>
    <div class="d-flex">
        <modal-step-by-step
            v-if="windowWidth > 578 && calendarSettings.modalEvents.eventId == null && isException"
            :modalTitle="
                !calendarSettings.modalEvents.eventId
                    ? $t('CalendarsPage.NewEvent')
                    : $t('CalendarsPage.EditEvent')
            "
            :isOpen="isOpen"
            :stepPosition="currentStep"
        />
        <ModalLinkResources
            isException
            @linkedResources="$emit('updateEvents')"
        />
        <ModalOptionsResource
            v-if="windowWidth > 480"
            @onUnlinkResource="openUnlinkModal"
            @close="flagToUnCheck += 1"
        />
        <ModalInfoResource
            :modalTitle="
                calendarSettings.modalEvents.eventId
                    ? calendarSettings.modalEvents.fields.name
                    : $t('CalendarsPage.EventInformation')
            "
            :device="windowWidth"
            :resourceInfo="resourceInfo"
            @onUnlink="openUnlinkModal"
        />
        <b-sidebar
            id="sidebar-modal-events"
            :class="[
                'sidebar-modal-events',
                {
                    '--steps':
                        windowWidth > 578 &&
                        calendarSettings.modalEvents.eventId == null &&
                        isException,
                    '--resource-options-modal-opened':
                        calendarSettings.resources.modal.isModalLinkResourcesOpen ||
                        isModalResourceInfoOpen ||
                        isModalResourceOptions,
                    '--settings-modal-opened': !isException && isModalSettingsOpen,
                    '--opened': isModalEventsOpen,
                    '--closed': !isModalEventsOpen
                }
            ]"
            right
            bg-variant="white"
            v-model="isOpen"
            :aria-hidden="false"
            @hidden="closeModal"
        >
            <template #header>
                <div
                    v-if="!isException || currentStep === 1 || calendarSettings.modalEvents.eventId"
                    class="header-sidebar d-flex justify-content-between"
                >
                    <span
                        v-if="!isException"
                        class="sidebar-title"
                    >
                        {{
                            !calendarSettings.modalEvents.eventId
                                ? $t("CalendarsPage.NewEvent")
                                : $t("CalendarsPage.EditEvent")
                        }}
                    </span>

                    <span
                        v-else
                        class="sidebar-title exception"
                        >{{
                            calendarSettings.modalEvents.eventId
                                ? calendarSettings.modalEvents.fields.name
                                : $t("CalendarsPage.EventInformation")
                        }}</span
                    >

                    <span
                        v-if="!isException || calendarSettings.modalEvents.eventId"
                        class="close-icon"
                        @click="closeModal()"
                    >
                        <CloseIcon />
                    </span>
                </div>
                <div
                    v-if="
                        !isException || calendarSettings.modalEvents.eventId || windowWidth <= 578
                    "
                    class="separator"
                ></div>
                <div
                    v-if="calendarSettings.modalEvents.eventId && isException"
                    class="modal-navbar"
                >
                    <div
                        :class="['info', currentStep === 1 ? 'active' : '']"
                        @click="currentStep = 1"
                    >
                        {{ $t("Informations") }}
                    </div>
                    <div
                        :class="['resource', currentStep === 2 ? 'active' : '']"
                        @click="currentStep = 2"
                    >
                        {{ $t("WorkcenterList.Resources") }}
                    </div>
                </div>
            </template>

            <template>
                <div
                    v-show="currentStep === 1 || !isException"
                    :class="[
                        'sidebar-modal-events__fields',
                        isException ? '--has-step-progress' : ''
                    ]"
                >
                    <sys-form-input
                        :label="$t('CalendarsPage.Name')"
                        :value="calendarSettings.modalEvents.fields.name"
                        :placeholder="$t('TypeHere')"
                        :state="calendarSettings.modalEvents.states.name.valid"
                        :feedback="$t(calendarSettings.modalEvents.states.name.feedback)"
                        @input="
                            (e) => {
                                flagEqualName = false;
                                UPDATE_MODAL_EVENTS_NAME_FIELD(e.target.value);
                            }
                        "
                    />

                    <div class="sidebar-modal-events__fields-row">
                        <div class="sidebar-modal-events__type-field">
                            <sys-form-select
                                :label="$t('CalendarsPage.Type')"
                                :placeholder="$t('Select')"
                                :value="calendarSettings.modalEvents.fields.exceptionEventType"
                                :options="context.calendarEventTypes"
                                :state="
                                    calendarSettings.modalEvents.states.exceptionEventType.valid
                                "
                                :feedback="
                                    $t(
                                        calendarSettings.modalEvents.states.exceptionEventType
                                            .feedback
                                    )
                                "
                                @input="(value) => UPDATE_MODAL_EVENTS_EVENT_TYPE_FIELD(value)"
                                translate
                            />
                        </div>

                        <div class="sidebar-modal-events__efficiency-field">
                            <sys-form-input
                                :label="$t('CalendarsPage.Efficiency')"
                                :value="calendarSettings.modalEvents.fields.efficiency"
                                :placeholder="$t('TypeHere')"
                                :state="calendarSettings.modalEvents.states.efficiency.valid"
                                :feedback="
                                    $t(calendarSettings.modalEvents.states.efficiency.feedback)
                                "
                                @input="(e) => handleInputEfficiency(e.target.value)"
                                @blur="handleBlurEfficiency()"
                                @keypress="(e) => handleKeyPressEfficiency(e)"
                                :disabled="
                                    calendarSettings.modalEvents.fields.exceptionEventType !=
                                        this.exceptionEventTypes.overtime &&
                                    calendarSettings.modalEvents.fields.exceptionEventType !=
                                        this.exceptionEventTypes.onShift
                                "
                            />
                        </div>
                    </div>

                    <sys-form-datepicker
                        id="date"
                        type="date"
                        :label="$t('CalendarsPage.Date')"
                        :value="calendarSettings.modalEvents.fields.date"
                        :state="calendarSettings.modalEvents.states.date.valid"
                        :feedback="$t(calendarSettings.modalEvents.states.date.feedback)"
                        @input="(value) => UPDATE_MODAL_EVENTS_DATE_FIELD(value)"
                    />

                    <div class="sidebar-modal-events__fields-row">
                        <div class="sidebar-modal-events__hour-fields">
                            <div class="sidebar-modal-events__starts-field">
                                <sys-form-datepicker
                                    id="starts"
                                    type="hour"
                                    :label="$t('CalendarsPage.Starts')"
                                    :value="calendarSettings.modalEvents.fields.startTime"
                                    :state="calendarSettings.modalEvents.states.startTime.valid"
                                    :feedback="
                                        $t(calendarSettings.modalEvents.states.startTime.feedback)
                                    "
                                    :disabled="calendarSettings.modalEvents.fields.allDay"
                                    @input="(value) => UPDATE_MODAL_EVENTS_START_TIME_FIELD(value)"
                                />
                            </div>

                            <div class="sidebar-modal-events__ends-field">
                                <sys-form-datepicker
                                    id="ends"
                                    type="hour"
                                    :label="$t('CalendarsPage.Ends')"
                                    :value="calendarSettings.modalEvents.fields.endTime"
                                    :state="calendarSettings.modalEvents.states.endTime.valid"
                                    :feedback="
                                        $t(calendarSettings.modalEvents.states.endTime.feedback)
                                    "
                                    :disabled="calendarSettings.modalEvents.fields.allDay"
                                    @input="(value) => UPDATE_MODAL_EVENTS_END_TIME_FIELD(value)"
                                />
                            </div>
                        </div>

                        <div class="sidebar-modal-events__all-day-field">
                            <sys-switch
                                size="md"
                                :value="calendarSettings.modalEvents.fields.allDay"
                                :label="$t('CalendarsPage.AllDayField')"
                                @input="handleOnInputAllDay"
                            />
                        </div>
                    </div>

                    <sys-form-input
                        :label="$t('CalendarsPage.Description')"
                        :value="calendarSettings.modalEvents.fields.description"
                        @input="(e) => UPDATE_MODAL_EVENTS_DESCRIPTION_FIELD(e.target.value)"
                        :placeholder="$t('TypeHere')"
                        height="98px"
                        textarea
                    />

                    <recurrence />
                </div>
                <div
                    v-if="currentStep === 2 && isException"
                    class="h-100"
                >
                    <Resources
                        :isRegister="calendarSettings.modalEvents.eventId == null && isException"
                        :flagToUnCheck="flagToUnCheck"
                        @onUnlinkResource="openUnlinkModal"
                        @openInfoResource="openInfoResource"
                    />
                </div>
            </template>

            <template #footer>
                <div
                    v-if="
                        isException && windowWidth <= 578 && !calendarSettings.modalEvents.eventId
                    "
                    class="step-action"
                >
                    <div class="d-flex justify-content-between">
                        <div
                            :class="[
                                'step-collapse',
                                isStepBlockOpenned ? 'not-collapsed' : 'collapsed'
                            ]"
                        >
                            {{ `${currentStep} ${$t("Of")} 2`
                            }}<span
                                id="step-collapse"
                                @click="openStepBlock()"
                                class="icon"
                            >
                                <ArrowDownIcon
                            /></span>
                        </div>
                        <div class="text">{{ $t(getModalTitle(currentStep)) }}</div>
                    </div>
                    <div class="step-progress">
                        <div
                            :class="[
                                'first-step',
                                currentStep === 1
                                    ? 'step-active'
                                    : currentStep > 1
                                      ? 'next-step'
                                      : ''
                            ]"
                        ></div>
                        <div
                            :class="[
                                'second-step',
                                currentStep === 2
                                    ? 'step-active'
                                    : currentStep > 2
                                      ? 'next-step'
                                      : ''
                            ]"
                        ></div>
                    </div>
                    <b-collapse :visible="isStepBlockOpenned">
                        <div class="progress-block">
                            <div class="separator-progress"></div>
                            <div class="detail-block">
                                <div
                                    :class="[
                                        'info-block',
                                        currentStep === 1
                                            ? 'step-active'
                                            : currentStep > 1
                                              ? 'next-step'
                                              : ''
                                    ]"
                                >
                                    <div class="icon"><InfoIcon /></div>
                                    <div class="text">
                                        {{ $t("PeoplePage.GeneralInformation") }}
                                    </div>
                                </div>
                                <div
                                    :class="[
                                        'vertical-separator',
                                        currentStep === 2 ? 'next-step' : ''
                                    ]"
                                ></div>
                                <div
                                    :class="[
                                        'attachments-block',

                                        currentStep === 2 ? 'step-active' : ''
                                    ]"
                                >
                                    <div class="icon"><ResourceIcon /></div>
                                    <div class="text">
                                        {{ $t("CalendarsPage.ResourceSelection") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
                <div
                    v-if="verifyFooterShow()"
                    :class="[
                        'sidebar-modal-events__footer-container',
                        isException && !calendarSettings.modalEvents.eventId
                            ? '--has-step-block'
                            : ''
                    ]"
                >
                    <div
                        :class="[
                            'sidebar-modal-events__footer-content-right',
                            calendarSettings.modalEvents.eventId !== null ? '--is-edit' : ''
                        ]"
                    >
                        <div class="sidebar-modal-periods__footer-delete">
                            <sys-button
                                v-if="calendarSettings.modalEvents.eventId !== null && !isException"
                                scheme="square"
                                variant="outline square-danger"
                                :size="handleFooterButtonSize()"
                                :full="windowWidth <= 480"
                                @click="handleDeleteEvent"
                            >
                                {{ $t("IntegrationPage.delete") }}
                            </sys-button>
                        </div>
                        <div class="sidebar-modal-periods__footer-buttons">
                            <sys-button
                                scheme="square"
                                variant="outline"
                                :size="handleFooterButtonSize()"
                                :full="isException ? windowWidth <= 578 : windowWidth <= 480"
                                @click="handleCancelEvent"
                                :noBorder="isException && currentStep === 2"
                            >
                                {{ $t("CalendarsPage.Cancel") }}
                            </sys-button>

                            <sys-button
                                v-if="!calendarSettings.modalEvents.eventId && currentStep !== 1"
                                scheme="square"
                                variant="outline"
                                :size="handleFooterButtonSize()"
                                :full="isException ? windowWidth <= 578 : windowWidth <= 480"
                                @click="previousStep()"
                            >
                                {{ $t("PeoplePage.Previous") }}
                            </sys-button>

                            <sys-button
                                v-if="
                                    isException &&
                                    !calendarSettings.modalEvents.eventId &&
                                    currentStep === 1
                                "
                                scheme="square"
                                variant="contained"
                                :size="handleFooterButtonSize()"
                                :full="windowWidth <= 578"
                                @click="handleNextStep"
                            >
                                {{ $t("RefuseStatus.Next") }}
                            </sys-button>
                            <sys-button
                                v-else
                                scheme="square"
                                variant="contained"
                                :size="handleFooterButtonSize()"
                                :full="isException ? windowWidth <= 578 : windowWidth <= 480"
                                @click="handleSaveEvent"
                            >
                                {{ $t("CalendarsPage.Save") }}
                            </sys-button>
                        </div>
                    </div>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import { BSidebar, BCollapse } from "bootstrap-vue";
    import SysButton from "@/@core/components/sys-button";
    import SysFormInput from "@/@core/components/sys-form-input";
    import SysFormDatepicker from "@/@core/components/sys-form-datepicker";
    import SysFormSelect from "@/@core/components/sys-form-select";
    import SysCheckbox from "@/@core/components/sys-checkbox";
    import SysSwitch from "@/@core/components/sys-switch";
    import Recurrence from "./Recurrence.vue";
    import exceptionEventTypes from "@/views/pages/calendar/enums/exceptionEventTypes";
    import frequency from "@/views/pages/calendar/enums/frequency";
    import modalStepByStep from "./ModalStepByStep.vue";
    import Resources from "./Resources.vue";
    import ModalLinkResources from "../ModalLinkResources.vue";
    import ModalOptionsResource from "../ModalOptionsResource.vue";
    import ModalInfoResource from "../ModalInfoResource.vue";
    import { saveCalendarService } from "@/views/pages/calendar/actionCalendar/services";
    import { timeToMinutes } from "@/views/pages/calendar/actionCalendar/utils/index.js";
    import moment from "moment";

    export default {
        data() {
            return {
                isOpen: false,
                exceptionEventTypes: exceptionEventTypes,
                frequency: frequency,
                currentStep: 1,
                flagToUnCheck: 1,
                isStepBlockOpenned: false,
                flagEqualName: false,
                resourceInfo: {}
            };
        },
        props: {
            isException: {
                type: Boolean,
                default: false
            }
        },
        components: {
            BSidebar,
            BCollapse,
            SysButton,
            SysFormInput,
            SysFormSelect,
            SysCheckbox,
            SysFormDatepicker,
            SysSwitch,
            Recurrence,
            modalStepByStep,
            Resources,
            ModalLinkResources,
            ModalOptionsResource,
            ModalInfoResource,
            AddIcon: () => import("@core/assets/icons/add-icon.svg"),
            CalendarIcon: () => import("@/assets/images/icons/calendar-icon.svg"),
            ArrowDownIcon: () => import("@core/assets/icons/arrow-down.svg"),
            SaveIcon: () => import("@core/assets/icons/save-icon.svg"),
            CloseIcon: () => import("@core/assets/icons/close-icon.svg"),
            InfoIcon: () => import("@core/assets/icons/info-icon.svg"),
            ResourceIcon: () => import("@core/assets/icons/select-resource-icon.svg")
        },
        methods: {
            ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
            ...mapMutations("calendar", [
                "UPDATE_MODAL_EVENTS_TOGGLE",
                "UPDATE_MODAL_EVENTS_NAME_FIELD",
                "UPDATE_MODAL_EVENTS_EVENT_TYPE_FIELD",
                "UPDATE_MODAL_EVENTS_EFFICIENCY_FIELD",
                "UPDATE_MODAL_EVENTS_DESCRIPTION_FIELD",
                "UPDATE_EVENT_LIST",
                "UPDATE_MODAL_EVENTS_ALL_DAY_FIELD",
                "UPDATE_MODAL_EVENTS_DATE_FIELD",
                "UPDATE_MODAL_EVENTS_START_TIME_FIELD",
                "UPDATE_MODAL_EVENTS_END_TIME_FIELD",
                "RESET_MODAL_EVENTS",
                "RESET_RESOURCES",
                "UPDATE_MODAL_EVENTS_STATES",
                "UPDATE_MODAL_EVENTS_RECURRENCE_START_DATE_FIELD",
                "UPDATE_MODAL_EVENTS_RECURRENCE_END_DATE_FIELD",
                "UPDATE_MODAL_EVENTS_RECURRENCE_QUANTITY_FIELD",
                "UPDATE_MODAL_EVENTS_RECURRENCE_FREQUENCY_FIELD",
                "UPDATE_MODAL_EVENTS_IS_RECURRENT_FIELD",
                "UPDATE_MODAL_EVENTS_RECURRENCE_DAYS_OF_WEEK_FIELD",
                "UPDATE_MODAL_EVENTS_RECURRENCE_DAYS_OF_MONTH_FIELD",
                "UPDATE_MODAL_EVENTS_RECURRENCE_WEEKS_OF_MONTH_FIELD",
                "UPDATE_MODAL_EVENTS_RECURRENCE_MONTHS_FIELD",
                "UPDATE_RESOURCES_LIST",
                "UPDATE_MODAL_OPTIONS_RESOURCE_TOGGLE",
                "UPDATE_MODAL_RESOURCE_INFO_TOGGLE",
                "RESET_MODAL_RESOURCES",
                "UPDATE_MODAL_RESOURCES_TOGGLE",
                "UPDATE_RESOURCES_TO_LINK_LIST",
                "UPDATE_MODAL_EVENTS_RECURRENCE_IS_ON_THE",
                "UPDATE_MODAL_EVENTS_RECURRENCE_IS_ON",
                "UPDATE_MODAL_PERIODS_TOGGLE"
            ]),
            handleOnInputAllDay(value) {
                this.UPDATE_MODAL_EVENTS_ALL_DAY_FIELD(value);

                this.UPDATE_MODAL_EVENTS_STATES({
                    ...this.calendarSettings.modalEvents.states,
                    startTime: {
                        valid: true,
                        feedback: ""
                    },
                    endTime: {
                        valid: true,
                        feedback: ""
                    }
                });
            },
            closeModal() {
                this.UPDATE_MODAL_EVENTS_TOGGLE(false);
                this.RESET_MODAL_EVENTS();
                const resourcesToLink = this.calendarSettings.resources.modal.resourcesToLink;
                resourcesToLink.map((e) => (e.checked = false));
                this.UPDATE_RESOURCES_TO_LINK_LIST(resourcesToLink);
                this.currentStep = 1;
                this.flagEqualName = false;

                if (this.calendarSettings.resources.modal.isModalLinkResourcesOpen) {
                    this.UPDATE_MODAL_RESOURCES_TOGGLE(false);
                    this.RESET_MODAL_RESOURCES();
                }
            },
            async openUnlinkModal(resource = null) {
                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                const copyResources = [...this.calendarSettings.resources.resourcesList];
                const checkedResources = copyResources.filter((e) => !!e.checked);
                const payload = checkedResources.map((e) => e.id);

                await this.$http2
                    .delete(
                        `/api/myconfig/exception-calendar/${this.calendarSettings.modalEvents.eventId}/remove-resources`,
                        {
                            data: resource ? [resource.id] : payload
                        }
                    )
                    .then((response) => {
                        this.UPDATE_MODAL_OPTIONS_RESOURCE_TOGGLE(false);
                        let resourcesRemaining = copyResources.filter(
                            (e) => !payload.includes(e.id)
                        );
                        if (resource) {
                            resourcesRemaining = copyResources.filter((e) => e.id !== resource.id);
                        }

                        this.UPDATE_RESOURCES_LIST(resourcesRemaining);
                        this.UPDATE_MODAL_RESOURCE_INFO_TOGGLE(false);
                        this.$setToast({
                            title: this.$t("IntegrationPage.success"),
                            icon: "SmileIcon",
                            text: this.$t("StructurePage.UnlinkedResources"),
                            variant: "success"
                        });
                        this.$emit("updateEvents");
                    })
                    .catch((error) => console.error(error))
                    .finally(() => this.UPDATE_FLAG_SHOW_OVERLAY(false));
            },
            openInfoResource(item) {
                this.resourceInfo = item;
            },
            formatEfficiency(value) {
                const formattedValue =
                    value === "." ? "" : value.replace(/[^0-9.]/g, "").replace(/^0(\d)/, "$1");

                return formattedValue;
            },
            openStepBlock() {
                this.isStepBlockOpenned = !this.isStepBlockOpenned;
            },
            getModalTitle(v) {
                if (v === 1) return "PeoplePage.GeneralInformation";
                if (v === 2) return "CalendarsPage.ResourceSelection";
            },
            handleBlurEfficiency() {
                let formattedValue = this.calendarSettings.modalEvents.fields.efficiency.replace(
                    /[^0-9.]/g,
                    ""
                );

                if (formattedValue[formattedValue.length - 1] == ".") {
                    formattedValue = formattedValue.replace(".", "");
                }

                this.UPDATE_MODAL_EVENTS_EFFICIENCY_FIELD(
                    formattedValue ? formattedValue + "%" : "0%"
                );
            },
            handleInputEfficiency(value) {
                const formattedValue = this.formatEfficiency(value);
                this.UPDATE_MODAL_EVENTS_EFFICIENCY_FIELD(formattedValue);
            },
            handleKeyPressEfficiency(event) {
                const key = event.key;

                // Permite apenas números e o ponto (.)
                if (!/[0-9.]/.test(key)) {
                    event.preventDefault(); // Impede a entrada de outros caracteres
                }

                if (
                    key === "." &&
                    this.calendarSettings.modalEvents.fields.efficiency.includes(".")
                ) {
                    event.preventDefault(); // Impede a inserção de mais de um ponto
                }
            },
            handleFooterButtonSize() {
                if (this.windowWidth > 768) {
                    return "md";
                }

                if (this.windowWidth > 480 && this.windowWidth <= 768) {
                    return "md";
                }

                if (this.windowWidth <= 480) {
                    return "xs";
                }
            },
            verifyFooterShow() {
                const isEditEvent = this.calendarSettings.modalEvents.eventId;

                if (!isEditEvent) return true;

                if (this.currentStep === 2) return false;

                return true;
            },
            adjustTimeZone3(date) {
                if (!(date instanceof Date)) {
                    date = new Date(date);
                }
                const offset = date.getTimezoneOffset() * 60000;
                const localISOTime = new Date(date.getTime() - offset).toISOString().slice(0, -1);

                return localISOTime;
            },
            handleSaveEvent() {
                this.flagEqualName = false;

                const handleCreate = (eventListCopy, newEvent) => {
                    eventListCopy.push(newEvent);
                    this.UPDATE_EVENT_LIST([...eventListCopy]);

                    this.$setToast({
                        title: this.$t("Success"),
                        icon: "SmileIcon",
                        text: this.$t("CalendarsPage.EventCreated"),
                        variant: "success"
                    });

                    this.closeModal();
                    saveCalendarService(this);
                };

                const handleEdit = (eventListCopy, newEvent) => {
                    const eventIndex = eventListCopy.findIndex((i) => i.id == newEvent.id);

                    if (eventIndex === -1) return;

                    eventListCopy[eventIndex] = { ...newEvent };

                    this.UPDATE_EVENT_LIST([...eventListCopy]);
                    this.closeModal();

                    saveCalendarService(this);
                };

                const formatRecurrence = (f, vm) => {
                    const recurrence = { ...f.recurrence };

                    if (!f.isRecurrent) return null;

                    if (recurrence.frequency === vm.frequency.day) {
                        recurrence.daysOfWeek = [];
                        recurrence.weeksOfMonth = [];
                        recurrence.months = [];
                    }

                    if (recurrence.frequency === vm.frequency.week) {
                        recurrence.daysOfMonth = [];
                        recurrence.weeksOfMonth = [];
                        recurrence.months = [];
                    }

                    if (recurrence.frequency === vm.frequency.month && recurrence.isOnThe) {
                        recurrence.daysOfWeek = [];
                        recurrence.weeksOfMonth = [];
                        recurrence.months = [];
                    }

                    if (recurrence.frequency === vm.frequency.month && recurrence.isOn) {
                        recurrence.daysOfMonth = [];
                        recurrence.months = [];
                    }

                    if (recurrence.frequency === vm.frequency.year && recurrence.isOnThe) {
                        recurrence.daysOfWeek = [];
                        recurrence.weeksOfMonth = [];
                    }

                    if (recurrence.frequency === vm.frequency.year && recurrence.isOn) {
                        recurrence.daysOfMonth = [];
                    }

                    return {
                        ...recurrence,
                        startDate: vm.adjustTimeZone3(recurrence.startDate),
                        endDate: recurrence.endDate ? vm.adjustTimeZone3(recurrence.endDate) : null,
                        frequencyId: recurrence.frequency,
                        quantity: Number(recurrence.quantity),
                        daysOfWeek: recurrence.daysOfWeek.map(Number),
                        daysOfMonth:
                            recurrence.frequency !== 1 ? recurrence.daysOfMonth.map(Number) : [],
                        weeksOfMonth: Array.isArray(recurrence.weeksOfMonth)
                            ? recurrence.weeksOfMonth.map(Number)
                            : [recurrence.weeksOfMonth],
                        months: Array.isArray(recurrence.months)
                            ? recurrence.months.map(Number)
                            : [recurrence.months]
                    };
                };

                const resultValidation = this.validateFields();

                if (!resultValidation) return;

                const eventList = [...this.calendarSettings.events.eventList];

                const fields = { ...this.calendarSettings.modalEvents.fields };
                const newEvent = {
                    id:
                        this.calendarSettings.modalEvents.eventId ??
                        crypto.getRandomValues(new Uint8Array(4)).join(""),
                    origin: this.calendarSettings.modalEvents.origin ?? "front",
                    name: fields.name,
                    calendarEventTypeId: fields.exceptionEventType,
                    efficiency:
                        this.calendarSettings.modalEvents.fields.exceptionEventType ==
                            this.exceptionEventTypes.overtime ||
                        this.calendarSettings.modalEvents.fields.exceptionEventType ==
                            this.exceptionEventTypes.onShift
                            ? Number(fields.efficiency.replace(/%/g, ""))
                            : 0,
                    date: this.adjustTimeZone3(fields.date),
                    startTime:
                        !fields.allDay && !!fields.startTime
                            ? this.adjustTimeZone3(fields.startTime)
                                  ?.split("T")?.[1]
                                  ?.substring(0, 5)
                            : null,
                    endTime:
                        !fields.allDay && !!fields.endTime
                            ? this.adjustTimeZone3(fields.endTime)?.split("T")?.[1]?.substring(0, 5)
                            : null,
                    allDay: fields.allDay,
                    description: fields.description || null,
                    isRecurrent: !!fields.isRecurrent,
                    recurrence: formatRecurrence(fields, this)
                };

                if (this.isException) {
                    const checkedResources = this.calendarSettings.resources.modal.resourcesToLink
                        .filter((e) => e.checked)
                        .map((e) => e.id);

                    const payload = {
                        name: newEvent.name,
                        description: newEvent.description,
                        eventTypeId: newEvent.calendarEventTypeId,
                        efficiency: newEvent.efficiency,
                        startTime: newEvent.startTime,
                        endTime: newEvent.endTime,
                        allDay: newEvent.allDay,
                        recurrent: newEvent.isRecurrent,
                        referenceDate: newEvent.date,
                        recurrence: newEvent.recurrence,
                        resource: checkedResources.length ? checkedResources : []
                    };
                    this.calendarSettings.modalEvents.eventId
                        ? this.handleEditExceptionEvent(
                              payload,
                              this.calendarSettings.modalEvents.eventId
                          )
                        : this.handleSaveExceptionEvent(payload);
                    return;
                }

                if (this.calendarSettings.modalEvents.eventId === null) {
                    handleCreate(eventList, newEvent);

                    return;
                }

                handleEdit(eventList, newEvent);
            },
            async handleSaveExceptionEvent(payload) {
                await this.$http2
                    .post(`api/myconfig/exception-calendar`, payload)
                    .then((response) => {
                        this.$setToast({
                            title: this.$t("Success"),
                            icon: "SmileIcon",
                            text: this.$t("CalendarsPage.EventCreated"),
                            variant: "success"
                        });
                        const resourcesToLink =
                            this.calendarSettings.resources.modal.resourcesToLink;
                        resourcesToLink.map((e) => (e.checked = false));
                        this.UPDATE_RESOURCES_TO_LINK_LIST(resourcesToLink);
                        this.closeModal();
                        this.$emit("updateEvents");
                    })
                    .catch((error) => {
                        error.response.data.errors.map((err) => {
                            if (err.id === 3) {
                                this.currentStep = 1;
                                this.flagEqualName = true;
                            } else {
                                this.$setToast({
                                    title: this.$t("Error"),
                                    icon: "FrownIcon",
                                    text: err.message,
                                    variant: "danger"
                                });
                            }
                        });
                        this.validateFields();
                    });
            },
            async handleEditExceptionEvent(payload, id) {
                await this.$http2
                    .put(`api/myconfig/exception-calendar/${id}`, payload)
                    .then((response) => {
                        this.$setToast({
                            title: this.$t("Success"),
                            icon: "SmileIcon",
                            text: this.$t("CalendarsPage.ChangesSaved"),
                            variant: "success"
                        });
                        this.closeModal();
                        this.$emit("updateEvents");
                    })
                    .catch((error) => {
                        error.response.data.errors.map((err) => {
                            if (err.id === 3) {
                                this.currentStep = 1;
                                this.flagEqualName = true;
                            } else {
                                this.$setToast({
                                    title: this.$t("Error"),
                                    icon: "FrownIcon",
                                    text: err.message,
                                    variant: "danger"
                                });
                            }
                        });
                        this.validateFields();
                    });
            },
            handleNextStep() {
                const resultValidation = this.validateFields();
                if (!resultValidation) return;

                this.currentStep += this.currentStep;
            },
            previousStep() {
                this.currentStep = this.currentStep - 1;
            },
            handleDeleteEvent() {
                if (!this.isException) {
                    this.$swal({
                        title: this.$t("IntegrationPage.attention"),
                        html: `<div>${this.$t("CalendarsPage.DeleteEventMessage1")} <b>${this.calendarSettings.modalEvents.fields.name}</b>. ${this.$t("CalendarsPage.DeleteEventMessage2")}</div>`,
                        showCancelButton: true,
                        showCloseButton: true,
                        cancelButtonText: this.$t("IntegrationPage.cancel"),
                        confirmButtonText: this.$t("IntegrationPage.delete"),
                        customClass: {
                            container: "swal-default",
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-danger ml-1"
                        },
                        buttonsStyling: false
                    }).then((result) => {
                        if (result.value) {
                            const eventList = [...this.calendarSettings.events.eventList];

                            const eventIndex = eventList.findIndex((event) => event.id == event.id);

                            if (eventIndex == -1) return;

                            eventList.splice(eventIndex, 1);
                            this.UPDATE_EVENT_LIST([...eventList]);

                            this.$setToast({
                                title: this.$t("Success"),
                                icon: "SmileIcon",
                                text: this.$t("CalendarsPage.EventDeleted"),
                                variant: "success"
                            });

                            saveCalendarService(this);
                            this.closeModal();
                        }
                    });
                }
            },
            validateFields() {
                const modalEvents = { ...this.calendarSettings.modalEvents };
                const fields = { ...modalEvents.fields };
                const states = { ...modalEvents.states };
                const events = { ...this.calendarSettings.events };

                const validations = {
                    name: () => {
                        if (!fields.name) {
                            states.name = {
                                valid: false,
                                feedback: "RequiredField"
                            };
                            return false;
                        }

                        const existingName = events.eventList.some((i) => i.name == fields.name);

                        if (
                            (existingName && modalEvents.initialName !== fields.name) ||
                            this.flagEqualName
                        ) {
                            states.name = {
                                valid: false,
                                feedback: "CalendarsPage.EqualName"
                            };

                            return false;
                        }

                        states.name = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    exceptionEventType: () => {
                        if (!fields.exceptionEventType?.toString()) {
                            states.exceptionEventType = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.exceptionEventType = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    efficiency: () => {
                        if (
                            !fields.efficiency &&
                            fields.exceptionEventTypes == this.exceptionEventTypes.overtime &&
                            fields.exceptionEventTypes == this.exceptionEventTypes.onShift
                        ) {
                            states.efficiency = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.efficiency = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    date: () => {
                        if (!fields.date) {
                            states.date = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.date = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    startTime: () => {
                        if (!fields.startTime && !fields.allDay) {
                            states.startTime = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.startTime = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    endTime: () => {
                        if (!fields.endTime && !fields.allDay) {
                            states.endTime = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        if (fields.endTime && fields.startTime && !fields.allDay) {
                            const formattedStartTime = fields.startTime
                                ? this.adjustTimeZone3(fields.startTime)
                                      ?.split("T")?.[1]
                                      ?.substring(0, 5)
                                : null;
                            const formattedEndTime = fields.endTime
                                ? this.adjustTimeZone3(fields.endTime)
                                      ?.split("T")?.[1]
                                      ?.substring(0, 5)
                                : null;

                            const startTimeInMinutes = timeToMinutes(formattedStartTime);
                            const endTimeInMinutes = timeToMinutes(formattedEndTime);

                            if (endTimeInMinutes <= startTimeInMinutes) {
                                states.endTime = {
                                    valid: false,
                                    feedback: "CalendarsPage.InvalidTime"
                                };

                                return false;
                            }
                        }

                        states.endTime = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    recurrence_startDate: () => {
                        if (!fields.isRecurrent) {
                            states.recurrence.startDate = {
                                valid: true,
                                feedback: ""
                            };

                            return true;
                        }

                        if (!fields.recurrence.startDate) {
                            states.recurrence.startDate = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.recurrence.startDate = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    recurrence_quantity: () => {
                        if (!fields.isRecurrent) {
                            states.recurrence.quantity = {
                                valid: true,
                                feedback: ""
                            };

                            return true;
                        }

                        if (!fields.recurrence.quantity || fields.recurrence.quantity == "0") {
                            states.recurrence.quantity = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.recurrence.quantity = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    recurrence_frequency: () => {
                        if (!fields.isRecurrent) {
                            states.recurrence.frequency = {
                                valid: true,
                                feedback: ""
                            };

                            return true;
                        }

                        if (!fields.recurrence.frequency) {
                            states.recurrence.frequency = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.recurrence.frequency = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    recurrence_daysOfMonth: () => {
                        if (
                            !fields.isRecurrent ||
                            fields.recurrence.frequency == this.frequency.day ||
                            fields.recurrence.frequency == this.frequency.week ||
                            !!fields.recurrence.isOn
                        ) {
                            states.recurrence.daysOfMonth = {
                                valid: true,
                                feedback: ""
                            };

                            return true;
                        }

                        if (
                            !fields.recurrence.daysOfMonth.length ||
                            (fields.recurrence.daysOfMonth.length &&
                                fields.recurrence.daysOfMonth[0] == "0")
                        ) {
                            states.recurrence.daysOfMonth = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.recurrence.daysOfMonth = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    recurrence_weeksOfMonth: () => {
                        const filteredArr = fields.recurrence.weeksOfMonth.length
                            ? fields.recurrence.weeksOfMonth[0]
                            : fields.recurrence.weeksOfMonth;
                        if (
                            !fields.isRecurrent ||
                            fields.recurrence.frequency === this.frequency.day ||
                            fields.recurrence.frequency === this.frequency.week
                        ) {
                            states.recurrence.weeksOfMonth = {
                                valid: true,
                                feedback: ""
                            };

                            return true;
                        }

                        if (!filteredArr) {
                            states.recurrence.weeksOfMonth = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.recurrence.weeksOfMonth = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    recurrence_daysOfWeek: () => {
                        if (
                            !fields.isRecurrent ||
                            fields.recurrence.frequency === this.frequency.day ||
                            fields.recurrence.frequency === this.frequency.week
                        ) {
                            states.recurrence.daysOfWeek = {
                                valid: true,
                                feedback: ""
                            };

                            return true;
                        }

                        if (!fields.recurrence.daysOfWeek[0]) {
                            states.recurrence.daysOfWeek = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.recurrence.daysOfWeek = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    },
                    recurrence_months: () => {
                        const isMonthValid = Array.isArray(fields.recurrence.months)
                            ? fields.recurrence.months[0]
                            : fields.recurrence.months;
                        if (
                            !fields.isRecurrent ||
                            fields.recurrence.frequency === this.frequency.day ||
                            fields.recurrence.frequency === this.frequency.week
                        ) {
                            states.recurrence.months = {
                                valid: true,
                                feedback: ""
                            };

                            return true;
                        }

                        if (!isMonthValid) {
                            states.recurrence.months = {
                                valid: false,
                                feedback: "RequiredField"
                            };

                            return false;
                        }

                        states.recurrence.months = {
                            valid: true,
                            feedback: ""
                        };

                        return true;
                    }
                };

                let isValid = true;

                for (const action of Object.values(validations)) {
                    const resultValidation = action?.();

                    if (isValid) {
                        isValid = resultValidation;
                    }
                }

                this.UPDATE_MODAL_EVENTS_STATES({ ...states });

                return isValid;
            },
            handleCancelEvent() {
                this.closeModal();
            },
            async handlePopulateFields(eventId) {
                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                await this.$http2
                    .get(`api/myconfig/exception-calendar/${eventId}`)
                    .then((res) => {
                        const response = res.data.data;
                        this.UPDATE_MODAL_EVENTS_NAME_FIELD(response.name);
                        this.UPDATE_MODAL_EVENTS_EVENT_TYPE_FIELD(response.eventTypeId);
                        this.UPDATE_MODAL_EVENTS_EFFICIENCY_FIELD(
                            response.efficiency > 0 ? String(response.efficiency) + "%" : "0%"
                        );
                        this.UPDATE_MODAL_EVENTS_DATE_FIELD(response.referenceDate);
                        this.UPDATE_MODAL_EVENTS_START_TIME_FIELD(
                            response?.startTime
                                ? new Date(
                                      moment().format("YYYY-MM-DD") + "T" + response?.startTime
                                  )
                                : null
                        );
                        this.UPDATE_MODAL_EVENTS_END_TIME_FIELD(
                            response?.endTime
                                ? new Date(moment().format("YYYY-MM-DD") + "T" + response?.endTime)
                                : null
                        );

                        this.UPDATE_MODAL_EVENTS_ALL_DAY_FIELD(response.allDay);
                        this.UPDATE_MODAL_EVENTS_DESCRIPTION_FIELD(response.description);
                        this.UPDATE_MODAL_EVENTS_IS_RECURRENT_FIELD(response.isRecurrent);
                        this.UPDATE_RESOURCES_LIST(response.resources);
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_START_DATE_FIELD(
                            response.recurrence.startDate
                        );
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_END_DATE_FIELD(
                            response.recurrence.endDate
                        );
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_QUANTITY_FIELD(
                            response.recurrence.quantity
                        );
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_FREQUENCY_FIELD(
                            response.recurrence.frequencyId
                        );
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_IS_ON_THE(response.recurrence.isOnThe);
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_IS_ON(response.recurrence.isOn);
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_DAYS_OF_WEEK_FIELD(
                            response.recurrence.daysOfWeek
                        );
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_DAYS_OF_MONTH_FIELD(
                            response.recurrence.daysOfMonth
                        );
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_WEEKS_OF_MONTH_FIELD(
                            response.recurrence.weeksOfMonth
                        );
                        this.UPDATE_MODAL_EVENTS_RECURRENCE_MONTHS_FIELD(
                            response.recurrence.months
                        );
                        this.handleBlurEfficiency();
                    })
                    .catch((error) => {
                        error.response.data.errors.map((e) => {
                            this.$setToast({
                                title: this.$t("IntegrationPage.Error"),
                                icon: "SmileIcon",
                                text: e.message,
                                variant: "danger"
                            });
                        });
                    })
                    .finally(() => {
                        this.UPDATE_FLAG_SHOW_OVERLAY(false);
                    });
            }
        },
        computed: {
            ...mapState("calendar", [
                "isModalEventsOpen",
                "calendarSettings",
                "context",
                "isModalResourceInfoOpen",
                "isModalResourceOptions",
                "isModalSettingsOpen"
            ]),
            ...mapState("app", ["windowWidth"])
        },
        watch: {
            isModalEventsOpen(v) {
                this.isOpen = v;
                const eventId = this.calendarSettings.modalEvents.eventId;
                if (eventId && this.isException) {
                    this.handlePopulateFields(eventId);
                }

                if (!v) {
                    this.UPDATE_MODAL_OPTIONS_RESOURCE_TOGGLE(false);
                    this.UPDATE_MODAL_RESOURCE_INFO_TOGGLE(false);
                } else {
                    this.UPDATE_MODAL_PERIODS_TOGGLE(false);
                }
            }
        }
    };
</script>

<style lang="scss">
    .sidebar-modal-events {
        @media (min-width: 1025px) {
            &.--opened.--resource-options-modal-opened {
                .b-sidebar.b-sidebar-right {
                    width: 407px;
                    right: 407px;
                }
            }
        }

        @media (min-width: 579px) and (max-width: 1024px) {
            &.--opened.--resource-options-modal-opened {
                .b-sidebar.b-sidebar-right {
                    width: 50vw;
                    right: 50vw;
                }
            }

            &.--opened.--settings-modal-opened {
                .b-sidebar.b-sidebar-right {
                    width: 50vw;
                    box-shadow: none;
                    border-left: 1px solid #cfc4be;

                    .separator {
                        opacity: 0;
                    }

                    .close-icon {
                        display: none;
                    }
                }
            }

            &.--opened.--steps {
                .b-sidebar.b-sidebar-right {
                    width: calc(100vw - 300px);
                    box-shadow: none;
                    border-left: 1px solid #cfc4be;
                }
            }

            &.--closed {
                .b-sidebar.b-sidebar-right {
                    box-shadow: none;
                }
            }
        }

        .b-sidebar {
            @media (max-width: 578px) {
                width: 100vw !important;
            }
        }

        .b-sidebar-header {
            display: contents;

            .header-sidebar {
                width: 100%;
                padding: 16px;

                .sidebar-title {
                    display: flex;
                    align-items: center;
                    color: #4c4541;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;

                    &.exception {
                        font-size: 16px;
                    }

                    @media (max-width: 480px) {
                        font-size: 16px;
                    }
                }

                .close-icon {
                    border: 1px solid #974900;
                    border-radius: 5px;
                    width: 28px;
                    height: 28px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    svg {
                        width: 12px;
                        height: 12px;
                        path {
                            fill: #974900;
                        }
                    }

                    &:hover {
                        background-color: #ffede2 !important;
                    }

                    &:active {
                        background-color: #ffdbc4 !important;
                    }
                }
            }

            .modal-navbar {
                display: flex;

                .info,
                .resource {
                    cursor: pointer;
                    width: 100%;
                    text-align: center;
                    color: #998f8a;
                    font-size: 16px;
                    font-weight: 600;
                    padding: 16px 0 14px;
                    border-bottom: 1px solid #cfc4be;

                    &.active {
                        color: #974900;
                        background: #fff;
                        box-shadow: 0px -4px 0px -1px #974900 inset;
                    }
                }
            }
        }

        .b-sidebar {
            width: 407px;
            box-shadow: 0px 4px 24px 0px rgba(58, 46, 38, 0.1);
            transition: all 0.5s ease-out;
            height: 100% !important;

            &:has(.--has-step-progress) {
                border-left: 1px solid #cfc4be;
                box-shadow: none;
            }

            .b-sidebar-body {
                padding: 0;

                &:has(.--no-events) {
                    overflow-y: hidden;
                }

                .col-md-12 {
                    padding: 0;
                }

                &::-webkit-scrollbar {
                    display: none !important;
                }
            }
        }

        .footer-sidebar {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px;

            .btn-apply {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                box-shadow: none;
                width: 100%;
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                letter-spacing: 0.175px;
                padding: 8px 0;
                border: 1px solid #974900 !important;
                background-color: #974900 !important;
                color: #ffff !important;

                svg {
                    width: 14px;
                    height: 14px;
                    fill: #fff;
                }

                &:hover {
                    box-shadow: none;
                }

                @media (max-width: 480px) {
                    font-size: 12px;
                    padding: 3px 0;
                }
            }

            .footer-events {
                display: flex;
                justify-content: space-between;
                gap: 8px;
                width: 100%;

                .year-block {
                    display: flex;
                    align-items: center;
                    padding: 4px 10px;
                    border-radius: 5px;
                    border: 1px solid #974900;

                    .years-dropdown {
                        padding: 0 8px 0 6px;
                    }

                    .arrow-icon,
                    .calendar-icon {
                        width: 14px;
                        height: 14px;
                        fill: #974900;
                    }

                    &:hover {
                        background-color: #ffede2 !important;
                    }

                    &:active {
                        background-color: #ffdbc4 !important;
                    }

                    @media (max-width: 480px) {
                        font-size: 12px;
                        padding: 0 10px;

                        svg {
                            width: 12px;
                            height: 12px;
                        }
                    }
                }

                .btn-new-event {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    letter-spacing: 0.175px;
                    border: 1px solid #974900 !important;
                    background-color: #974900 !important;
                    padding: 8px 14px;

                    svg {
                        width: 14px;
                        height: 14px;
                        fill: #fff;
                    }

                    &:hover {
                        box-shadow: none;
                    }

                    @media (max-width: 480px) {
                        font-size: 12px;
                        padding: 3px 14px;

                        svg {
                            width: 12px;
                            height: 12px;
                        }
                    }
                }

                .dropdown-toggle {
                    padding: 0;
                    color: #974900;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    letter-spacing: 0.175px;
                }

                .custom-dropdown-menu {
                    max-height: 200px;
                    overflow-y: auto;

                    .selected-year {
                        background-color: #974900;

                        .dropdown-item {
                            color: #fff;
                        }

                        .dropdown-item:hover,
                        .dropdown-item:focus {
                            color: #fff;
                        }

                        .dropdown-item:active {
                            background: #974900;
                        }
                    }

                    .dropdown-item:hover,
                    .dropdown-item:focus {
                        color: #974900;
                    }

                    .dropdown-item:active {
                        background: #ffdbc4;
                    }
                }
            }

            &.--no-events {
                border: none;
                padding: 0;

                .footer-events {
                    display: none;
                }
            }
        }

        .step-action {
            padding: 16px 0;
            border-top: 1px solid #cfc4be;

            .step-collapse {
                padding-left: 16px;
            }

            .step-collapse,
            .text {
                display: flex;
                gap: 8px;
                color: #4c4541;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
                .icon {
                    svg {
                        width: 16px;
                        height: 16px;
                        fill: #974900;
                    }
                }

                &.not-collapsed {
                    svg {
                        transform: rotate(-180deg);
                        transition: all 0.3s;
                    }
                }

                &.collapsed {
                    svg {
                        transform: rotate(0);
                        transition: all 0.3s;
                    }
                }
            }
            .text {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-right: 16px;
            }

            .step-progress {
                display: flex;
                gap: 4px;
                padding: 4px 16px 0;
                .first-step,
                .second-step,
                .third-step {
                    width: 50%;
                    height: 4px;
                    border-radius: 4px;
                    background: #f4eee8;

                    &.step-active {
                        background: #974900;
                    }

                    &.next-step {
                        background: #66bb6a;
                    }
                }
            }
        }

        .progress-block {
            padding-top: 16px;

            .detail-block {
                padding: 16px 16px 0;

                .info-block,
                .attachments-block,
                .times-block {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    .icon {
                        display: flex;
                        align-items: center;
                        width: 30px;
                        height: 30px;
                        padding: 7px;
                        border-radius: 50%;
                        border: 1px solid #cfc4be;

                        svg {
                            width: 14px;
                            height: 14px;
                            fill: #cfc4be;
                        }
                    }

                    .text {
                        overflow: hidden;
                        color: #cfc4be;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 26px;
                    }

                    &.step-active {
                        .icon {
                            border-color: #974900;
                            svg {
                                fill: #974900;
                            }
                        }

                        .text {
                            color: #974900;
                        }
                    }

                    &.next-step {
                        .icon {
                            border-color: #66bb6a;
                            background: #66bb6a;
                            svg {
                                fill: #fff;
                            }
                        }

                        .text {
                            color: #66bb6a;
                        }
                    }
                }

                .vertical-separator {
                    margin-left: 14px;
                    width: 1px;
                    height: 16px;
                    background: #cfc4be;

                    &.step-active {
                        background: #974900;
                    }

                    &.next-step {
                        background: #66bb6a;
                    }
                }
            }
        }

        .separator {
            width: 100%;
            height: 1px;
            background: #cfc4be;
            z-index: 2;
        }

        .sidebar-modal-events__fields {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding: 16px;

            .sidebar-modal-events__fields-row {
                display: flex;
                align-items: flex-start;
                gap: 16px;
                width: 100%;
            }

            .sidebar-modal-events__hour-fields {
                display: flex;
                align-items: flex-start;
                gap: 16px;
            }

            .sidebar-modal-events__type-field,
            .sidebar-modal-events__efficiency-field {
                min-width: calc(50% - 8px);
                max-width: calc(50% - 8px);
            }

            .sidebar-modal-events__starts-field,
            .sidebar-modal-events__ends-field {
                min-width: 113px;
                max-width: 113px;
            }

            .sidebar-modal-events__all-day-field {
                margin-top: 39px;
                display: flex;
            }
        }

        .sidebar-modal-events__footer-container {
            border-top: 1px solid #cfc4be;
            padding: 15.5px 16px;
            display: flex;
            .sidebar-modal-events__footer-content-right {
                margin-left: auto;
                display: flex;
                gap: 8px;

                .sidebar-modal-periods__footer-buttons {
                    display: flex;
                    justify-content: flex-end;
                    gap: 8px;
                    width: 100%;
                }

                &.--is-edit {
                    justify-content: space-between;
                    width: 100%;
                    margin-left: 0;
                    .sidebar-modal-periods__footer-delete {
                        width: 33%;
                        .sidebar-modal-periods__footer-buttons {
                            width: 66%;
                            justify-content: flex-end;
                        }
                    }
                }
            }

            &.--has-step-block {
                @media (max-width: 578px) {
                    border-top: 1px solid #eee;
                    .sidebar-modal-events__footer-content-right {
                        width: 100%;
                        margin-left: initial !important;
                        display: flex;
                        gap: 8px;
                    }
                }
            }
        }
    }

    @media (min-width: 768px) and (max-width: 814px) {
        .sidebar-modal-events__fields {
            .sidebar-modal-events__starts-field,
            .sidebar-modal-events__ends-field {
                min-width: 101.5px !important;
                max-width: 101.5px !important;
            }
        }
    }

    @media (max-width: 767px) {
        .sidebar-modal-events__fields {
            .sidebar-modal-events__fields-row {
                flex-direction: column !important;
            }

            .sidebar-modal-events__type-field,
            .sidebar-modal-events__efficiency-field {
                min-width: 100% !important;
                max-width: 100% !important;
            }

            .sidebar-modal-events__starts-field,
            .sidebar-modal-events__ends-field {
                min-width: initial !important;
                max-width: initial !important;
            }

            .sidebar-modal-events__all-day-field {
                margin-top: 0 !important;
            }
        }

        .sidebar-modal-events__footer-container {
            border-top: 1px solid #cfc4be;
            padding: 15.5px 16px;
            display: flex;
            .sidebar-modal-events__footer-content-right {
                width: 100%;
                margin-left: initial !important;
                display: flex;
                gap: 8px;
            }
        }
    }
</style>
